import { Box, Button, Center } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useEffect, useState } from "react";
import { AxioLoader } from "./AxioLoader";
import { AUTH_IDENTITY_COPY } from "../lib/kyc";
import { authApi } from "../lib/api";
import { startAppleRedirect } from "../lib/appleAuth";
import { axioTokens } from "../theme";

interface Props {
  returnPath?: string;
}

function AppleMark() {
  return (
    <svg width={axioTokens.unit[16]} height={axioTokens.unit[16]} viewBox="0 0 16 16" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12.62 8.54c-.02-1.93 1.58-2.86 1.65-2.9-.9-1.32-2.3-1.5-2.8-1.52-1.19-.12-2.32.7-2.92.7-.6 0-1.53-.68-2.52-.66-1.3.02-2.5.76-3.17 1.92-1.35 2.34-.35 5.8.97 7.7.64.93 1.4 1.98 2.4 1.94 1-.04 1.37-.62 2.58-.62 1.2 0 1.54.62 2.59.6 1.07-.02 1.75-.95 2.4-1.89.75-1.1 1.06-2.16 1.08-2.22-.02-.01-2.07-.8-2.1-3.15ZM10.7 3.4c.54-.66.91-1.57.81-2.48-.78.03-1.73.52-2.29 1.18-.5.58-.94 1.5-.82 2.39.87.07 1.76-.44 2.3-1.09Z"
      />
    </svg>
  );
}

export function AppleSignInButton({ returnPath = "/login" }: Props) {
  const [configLoading, setConfigLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    let cancelled = false;
    authApi
      .publicConfig()
      .then((config) => {
        if (!cancelled) setEnabled(Boolean(config.apple_enabled && config.apple_client_id && config.apple_redirect_uri));
      })
      .catch(() => {
        if (!cancelled) setEnabled(false);
      })
      .finally(() => {
        if (!cancelled) setConfigLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (configLoading) {
    return (
      <Center h="var(--axio-unit-40)">
        <AxioLoader size="sm" />
      </Center>
    );
  }

  if (!enabled) return null;

  return (
    <Box className="appleButtonWrap">
      <Button
        fullWidth
        className="appleAuthButton"
        data-testid="auth-apple-method"
        loading={starting}
        leftSection={<AppleMark />}
        onClick={async () => {
          setStarting(true);
          try {
            const config = await authApi.publicConfig();
            startAppleRedirect(config, returnPath);
          } catch (err) {
            setStarting(false);
            notifications.show({
              color: "red",
              title: "Failed",
              message: err instanceof Error ? err.message : AUTH_IDENTITY_COPY.appleSignInFailed,
            });
          }
        }}
      >
        {AUTH_IDENTITY_COPY.appleButton}
      </Button>
    </Box>
  );
}
